import { AddProduct } from "api/models/request/product/product";
import { createDomainPagedAutoCompleteMetaData } from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { string } from "yup";
export const productFormSchema = (): ObjectSchemaType<AddProduct> => ({
  customerId: {
    type: InputType.autoComplete,
    gridSize: 12,
    label: "Tên giao dịch",
    validattionYupSchema: string().required(),
    metaData: createDomainPagedAutoCompleteMetaData("customer"),
  },
  code: {
    type: InputType.text,
    gridSize: 5,
    label: "Mã hàng",
    validattionYupSchema: string().required().max(50),
  },
  name: {
    type: InputType.text,
    gridSize: 7,
    label: "Tên hàng",
    validattionYupSchema: string().required().max(255),
  },
  unitOfCalculation: {
    type: InputType.text,
    gridSize: 5,
    label: "Đơn vị tính",
    validattionYupSchema: string().max(50).required(),
  },
  barcode: {
    type: InputType.text,
    gridSize: 7,
    label: "Mã vạch",
    validattionYupSchema: string().max(255).required(),
  },
  isDisabled: {
    type: InputType.checkbox,
    gridSize: 12,
    label: "Ngưng sản xuất",
  },
});
